module.exports = __webpack_public_path__ + "static/media/Banner-Desktop-Minha-Claro-Channels.ad4ada03.png";